import { Link } from "react-router-dom";

interface MangaCardProps {
  id: string;
  title: string;
  author: string;
  cover: string;
  tags: string[];
  rating: number;
  chapters: number;
  status: string;
  categoryName: string;
  updatedAt: string;
}

export default function MangaCard({ id, title, author, cover, tags, rating, chapters, status, categoryName, updatedAt }: MangaCardProps) {
  return (
    <Link
      to={`/manga/${id}`}
      className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
      data-product-shop=""
    >
      <div className="aspect-[3/4] overflow-hidden relative">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-white">
            {categoryName}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${
            status === "已完结"
              ? "bg-foreground-900/70 text-white"
              : "bg-accent-500 text-white"
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1 text-white text-xs">
            <i className="ri-star-fill text-yellow-400 text-xs"></i>
            <span className="font-semibold">{rating}</span>
            <span className="text-white/70 ml-2">{chapters}话</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{author}</p>
        <div className="flex items-center gap-1.5 mt-2 flex-wrap">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="text-xs text-foreground-400 mt-2">
          更新于 {updatedAt}
        </p>
      </div>
    </Link>
  );
}